import { useCallback } from 'react';

import { useCommentsData } from '@confluence/comments-data/entry-points/useCommentsData';
import { useCommentsPanelActions } from '@confluence/comments-panel-utils/entry-points/useCommentsPanel';
import { fg } from '@confluence/feature-gating';
import {
	useUnreadCommentsActions,
	useUnreadComments,
} from '@confluence/unread-comments/entry-points/useUnreadComments';
import { useViewedComments } from '@confluence/unread-comments/entry-points/useViewedComments';

import {
	createReadCommentsDataMap,
	getCommentIdsByTypeAndAnnotationId,
} from '../helper/commentHelpers';

export const useSyncReadComments = (pageId?: string) => {
	const { setCommentsToBeMarkedAsRead } = useCommentsPanelActions();
	const [{ commentsDataMap }, { setCommentsDataMap }] = useCommentsData();
	const { updateUnreadCommentIDSet } = useUnreadCommentsActions();
	const [{ unreadCommentIDSet }, { setShouldClearVisibleThreads }] = useUnreadComments();
	const { updateViewedCommentsCache } = useViewedComments({ pageId: pageId || '' });

	return useCallback(() => {
		if (fg('confluence_frontend_unread_comments_fixes')) {
			// Update the unread comments store
			// Get all current unread comment IDs to add to viewed comments cache
			const unreadCommentIds = Array.from(unreadCommentIDSet);

			// Add all unread comments to viewed comments cache
			if (pageId && unreadCommentIds.length > 0) {
				updateViewedCommentsCache(unreadCommentIds);
			}

			// Clear all unread comments
			updateUnreadCommentIDSet(new Set());
			setShouldClearVisibleThreads(true);
		} else {
			setCommentsToBeMarkedAsRead(getCommentIdsByTypeAndAnnotationId(commentsDataMap));
			setCommentsDataMap(createReadCommentsDataMap(commentsDataMap));
		}
	}, [
		commentsDataMap,
		setCommentsToBeMarkedAsRead,
		setCommentsDataMap,
		updateUnreadCommentIDSet,
		unreadCommentIDSet,
		pageId,
		updateViewedCommentsCache,
		setShouldClearVisibleThreads,
	]);
};
